import type { PlatformProductCategory } from '~/graphql/graphql';
import { textValueOf } from '~/types/filters';
import {
  formsClause,
  isPropertyField,
  type ProductFilterRow,
} from './filterClauses';

/** The category select is held as a row so the shared saved-filter hook stores it with the rows. */
export const CATEGORY_FIELD = 'category';
const CATEGORY_ROW_ID = 'category';

export function categoryOf(
  rows: ProductFilterRow[]
): PlatformProductCategory | undefined {
  const categoryRow = rows.find((row) => row.field === CATEGORY_FIELD);
  const category = categoryRow ? textValueOf(categoryRow) : '';
  return category === '' ? undefined : (category as PlatformProductCategory);
}

export function withoutCategory(rows: ProductFilterRow[]): ProductFilterRow[] {
  return rows.filter((row) => row.field !== CATEGORY_FIELD);
}

export function withCategory(
  rows: ProductFilterRow[],
  category: string | undefined
): ProductFilterRow[] {
  const filterRows = withoutCategory(rows);
  if (!category) return filterRows;
  return [
    {
      id: CATEGORY_ROW_ID,
      field: CATEGORY_FIELD,
      operator: 'eq',
      value: category,
      connector: 'and',
    },
    ...filterRows,
  ];
}

/** Property rows belong to one category, so a new category drops them. */
export function changeCategory(
  rows: ProductFilterRow[],
  category: string | undefined
): ProductFilterRow[] {
  return withCategory(
    rows.filter((row) => !isPropertyField(row.field)),
    category
  );
}

export function activeRowCount(
  rows: ProductFilterRow[],
  fields?: string[]
): number {
  const categoryCount = categoryOf(rows) ? 1 : 0;
  const clauseCount = withoutCategory(rows).filter((row) =>
    formsClause(row, fields)
  ).length;
  return categoryCount + clauseCount;
}
